module.exports = "/newsfeed/newsfeed-pages-management-185f65.html";